import { render, staticRenderFns } from "./Birth.vue?vue&type=template&id=95263676&scoped=true&"
import script from "./Birth.vue?vue&type=script&lang=js&"
export * from "./Birth.vue?vue&type=script&lang=js&"
import style0 from "./Birth.vue?vue&type=style&index=0&id=95263676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95263676",
  null
  
)

export default component.exports